module.exports = __webpack_public_path__ + "static/icon-circle-sunrise-23c2df8783741ecc033ba3afa8ca201f.png";